export const UPDATE_TRIAGE_DEMOGRAPHICS = 'UPDATE_TRIAGE_DEMOGRAPHICS'
export const CLEAR_TRIAGE_DEMOGRAPHICS = 'CLEAR_TRIAGE_DEMOGRAPHICS'

// @ts-expect-error TS(7006): Parameter 'category' implicitly has an 'any' type.
export const updateTriageDemographics = (category, value) => ({
  type: UPDATE_TRIAGE_DEMOGRAPHICS,
  category,
  value,
})
